exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".toolbar[data-v-ae5f345c]{display:-webkit-box;display:-ms-flexbox;display:flex;width:calc(100% - 12rem);-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:rows;flex-direction:rows;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:fixed;top:4rem;left:12rem;right:0;background:#f6f6f6;border-bottom:1px solid rgba(0,0,0,.05);height:4rem;padding-left:1rem;padding-right:1rem;z-index:450;box-shadow:0 0 6px 0 rgba(0,0,0,.1)}.toolbar .toolbar-left[data-v-ae5f345c]{text-align:left}.toolbar .toolbar-left .toolbar-title[data-v-ae5f345c]{font-weight:600;font-size:1.2rem;color:#333}.toolbar .toolbar-right[data-v-ae5f345c]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ae5f345c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/Toolbar.vue
// module id = 515
// module chunks = 0